var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "formRef",
      attrs: { model: _vm.form, rules: _vm.rules, "label-width": "140px" },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "商品名称", prop: "productName" } },
        [
          _c("el-input", {
            staticStyle: { width: "400px" },
            model: {
              value: _vm.form.productName,
              callback: function ($$v) {
                _vm.$set(_vm.form, "productName", $$v)
              },
              expression: "form.productName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "渠道", prop: "type" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "300px" },
              attrs: { placeholder: "请选择渠道", disabled: !!_vm.form.id },
              on: { change: _vm.changeType },
              model: {
                value: _vm.form.type,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "type", $$v)
                },
                expression: "form.type",
              },
            },
            [
              _c("el-option", { attrs: { label: "广发银行", value: 1 } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "建设银行", value: 2 } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "优惠券组合", prop: "" } },
        _vm._l(_vm.form.details, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "margin-bottom": "20px",
              },
            },
            [
              _c("div", [
                _c(
                  "div",
                  [
                    !!_vm.form.id
                      ? _c("el-input", {
                          staticStyle: {
                            width: "300px",
                            "margin-right": "10px",
                          },
                          attrs: { disabled: "" },
                          model: {
                            value: item.couponName,
                            callback: function ($$v) {
                              _vm.$set(item, "couponName", $$v)
                            },
                            expression: "item.couponName",
                          },
                        })
                      : _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "300px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              placeholder: "请输入优惠券，支持模糊查询",
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              "remote-method": _vm.fetchCoupons1,
                              loading: _vm.couponLoading,
                            },
                            model: {
                              value: item.couponId,
                              callback: function ($$v) {
                                _vm.$set(item, "couponId", $$v)
                              },
                              expression: "item.couponId",
                            },
                          },
                          _vm._l(_vm.couponOptions1, function (coupon) {
                            return _c("el-option", {
                              key: coupon.thirdCouponId,
                              attrs: {
                                label: coupon.typeName,
                                value: coupon.thirdCouponId,
                              },
                            })
                          }),
                          1
                        ),
                    _vm._v("\n\n                    数量："),
                    _c("el-input", {
                      staticStyle: { width: "100px" },
                      attrs: { disabled: !!_vm.form.id },
                      model: {
                        value: item.quantity,
                        callback: function ($$v) {
                          _vm.$set(item, "quantity", $$v)
                        },
                        expression: "item.quantity",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { margin: "10px 0" } },
                  [
                    _vm._v("\n                    每日上限库存："),
                    _c("el-input", {
                      staticStyle: { width: "100px", "margin-right": "100px" },
                      model: {
                        value: item.dailyStockLimit,
                        callback: function ($$v) {
                          _vm.$set(item, "dailyStockLimit", $$v)
                        },
                        expression: "item.dailyStockLimit",
                      },
                    }),
                    _vm._v("\n                    总库存："),
                    _c("el-input", {
                      staticStyle: { width: "100px" },
                      model: {
                        value: item.totalStock,
                        callback: function ($$v) {
                          _vm.$set(item, "totalStock", $$v)
                        },
                        expression: "item.totalStock",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm._v("\n                    B端售卖价格："),
                    _c("el-input", {
                      staticStyle: { width: "100px", "margin-right": "100px" },
                      model: {
                        value: item.bPrice,
                        callback: function ($$v) {
                          _vm.$set(item, "bPrice", $$v)
                        },
                        expression: "item.bPrice",
                      },
                    }),
                    _vm._v("\n                    商品原价："),
                    _c("el-input", {
                      staticStyle: { width: "100px", "margin-right": "100px" },
                      model: {
                        value: item.oPrice,
                        callback: function ($$v) {
                          _vm.$set(item, "oPrice", $$v)
                        },
                        expression: "item.oPrice",
                      },
                    }),
                    _vm._v("\n                    C端销售价："),
                    _c("el-input", {
                      staticStyle: { width: "100px" },
                      model: {
                        value: item.cPrice,
                        callback: function ($$v) {
                          _vm.$set(item, "cPrice", $$v)
                        },
                        expression: "item.cPrice",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "映射编码" } },
        [
          _c("el-input", {
            staticStyle: { width: "300px" },
            model: {
              value: _vm.form.mappingCode,
              callback: function ($$v) {
                _vm.$set(_vm.form, "mappingCode", $$v)
              },
              expression: "form.mappingCode",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "是否启用" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "status", $$v)
                },
                expression: "form.status",
              },
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
              _vm._v(" "),
              _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }